import { useAnalyticsGroupWidgetContext } from "../../../../helpers/hooks/useAnalyticsGroupWidgetContext";
import sampleWidgetsList from "../../utils/sampleWidgetsList";
import UndefinedWidget from "../sampleWidgets/undefinedWidget";

const AnalyticsGroupWidgetsSampleFactory = () => {
  const widget = useAnalyticsGroupWidgetContext();
  const WidgetComponent = sampleWidgetsList.find(
    (sampleWidget) => sampleWidget.type === widget.widgetMeta.type
  )?.component;
  if (!WidgetComponent) {
    return <UndefinedWidget />;
  }
  return <WidgetComponent />;
};

export default AnalyticsGroupWidgetsSampleFactory;
